<template>
  <div class="wrapper" ref="wrapper">
    <div class="header-wrapper">
      <div class="header">事件查询</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="onSearch">搜索</Button>
        <Button class="bkcc-btn" @click="searchReset">重置</Button>
        <Button class="bkcc-btn" @click="exportTable">导出</Button>
      </div>
    </div>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="事件单号" prop="reportId">
                <i-input
                  v-model="query.reportId"
                  clearable
                  placeholder="请填写事件单号"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="事件来源" prop="reportfromname">
                <i-select
                  v-model="query.reportfromname"
                  @on-change="selChange"
                  clearable
                  placeholder="请选择事件来源"
                >
                  <i-option
                    :value="item.name"
                    style="width: 100%"
                    v-for="item in reportfromName"
                    :key="item.value"
                    >{{ item.name }}</i-option
                  >
                </i-select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="事件详情" prop="title">
                <i-input
                  v-model="query.title"
                  clearable
                  placeholder="请输入事件详情"
                />
              </form-item>
            </i-col>
          </row>
          <row :gutter="80">
            <i-col span="6">
              <form-item label="上报人" prop="createuser">
                <i-input
                  v-model="query.createuser"
                  clearable
                  placeholder="请输入上报人"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="上报时间" prop="eventtime">
                <date-picker
                  type="daterange"
                  style="width: 100%"
                  v-model="query.eventtime"
                  placeholder="请选择上报时间"
                />
              </form-item>
            </i-col>
            <i-col span="6" v-if="isJiedao == 1">
              <form-item label="行政区域" prop="reportCompany">
                <i-select
                  v-model="query.reportCompany"
                  clearable
                  placeholder="请选择行政区域"
                >
                  <i-option
                    :value="item.name"
                    v-for="item in reportCompany"
                    :key="item.value"
                    >{{ item.name }}</i-option
                  >
                </i-select>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-tabs">
        <tabs v-model="cate" @on-click="clickChange" :animated="false">
          <div class="publicBtn">
            <Button class="bkcc-btn" @click="eventIsShow">{{
              tableIndex != 6 ? "公示" : "取消公示"
            }}</Button>
            <Button style="display: none"></Button>
          </div>
          <tab-pane label="全部事件" name="0" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="tableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                stripe
                ref="table"
                @on-row-dblclick="handleClickDetail"
                @on-selection-change="handleSelect"
              />
              <div class="page">
                <page :total="total" @on-change="pageChange" show-total />
              </div>
            </div>
          </tab-pane>
          <tab-pane label="待办事件" name="1" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="tableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                @on-row-dblclick="handleClickDetail"
                @on-selection-change="handleSelect"
              />
              <div class="page">
                <page :total="total" @on-change="pageChange" show-total />
              </div>
            </div>
          </tab-pane>
          <tab-pane label="办理中" name="2" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="tableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                @on-row-dblclick="handleClickDetail"
                @on-selection-change="handleSelect"
              />
              <div class="page">
                <page :total="total" @on-change="pageChange" show-total />
              </div>
            </div>
          </tab-pane>
          <tab-pane label="待核实" name="3" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="tableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                @on-row-dblclick="handleClickDetail"
                @on-selection-change="handleSelect"
              />
              <div class="page">
                <page :total="total" @on-change="pageChange" show-total />
              </div>
            </div>
          </tab-pane>
          <tab-pane label="待评价" name="4" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="tableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                @on-row-dblclick="handleClickDetail"
                @on-selection-change="handleSelect"
              />
              <div class="page">
                <page :total="total" @on-change="pageChange" show-total />
              </div>
            </div>
          </tab-pane>
          <tab-pane label="已完结" name="5" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="tableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                @on-row-dblclick="handleClickDetail"
                @on-selection-change="handleSelect"
              />
              <div class="page">
                <page :total="total" @on-change="pageChange" show-total />
              </div>
            </div>
          </tab-pane>
          <tab-pane label="已公示" name="6" :disabled="isTableLoading">
            <div class="table-data">
              <i-table
                :columns="tableHeader"
                :border="true"
                :loading="isTableLoading"
                :data="tableData"
                @on-row-dblclick="handleClickDetail"
                @on-selection-change="handleSelect"
              />
              <div class="page">
                <page :total="total" @on-change="pageChange" show-total />
              </div>
            </div>
          </tab-pane>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "eventQuery",
  data() {
    return {
      query: {
        title: "",
        createuser: "",
        eventtime: [],
        reportfromname: "",
        reportCompany: "",
      },
      reportfromName: [
        {
          name: "先锋e家",
          value: "xfej",
        },
        {
          name: "民生通",
          value: "mst",
        },
        {
          name: "社区云助手",
          value: "sqyzs",
        },
        {
          name: "东乡百事通",
          value: "dxbst",
        },
      ],
      reportCompany: [],
      isTableLoading: false,
      total: 0,
      cate: "0",
      tableHeader: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "单号",
          key: "businesskey",
        },
        {
          title: "流程状态",
          key: "state",
          width: 150,
        },
        {
          title: "事件来源",
          key: "from",
          width: 150,
        },
        {
          title: "事件详情",
          key: "title",
        },
        {
          title: "上报部门",
          key: "bumen",
        },
        {
          title: "上报人",
          key: "people",
          width: 150,
        },
        {
          title: "上报时间",
          key: "time",
        },
        {
          title: "居民评价",
          key: "evaluation",
        },
      ],
      tableData: [],
      selectedList: [],
      isJiedao: 0,
      page: 1,
      rows: 10,
      selectVal: {
        title: "",
        createuser: "",
        eventtime: "",
        reportfromname: "",
        communityIdList: [],
        userid: "-1",
        reportId: "",
      },
      tableList: [66, -1, 1, 55, 77, 88, 66],
      tableIndex: 0,
    };
  },
  methods: {
    pageChange(val) {
      console.log(val);
      this.page = val;
      this.getSqEvent(this.selectVal);
    },
    clickChange(val) {
      console.log(val);
      this.tableIndex = val;
      this.page = 1;
      this.getSqEvent(this.selectVal);
    },
    handleSelect(selection) {
      this.selectedList = [];
      selection.forEach((item) => {
        this.selectedList.push(item.businesskey);
      });
    },
    eventIsShow() {
      if (this.selectedList.length == 0) {
        return this.$Message.warning("请选择");
      }
      let url = this.urlobj.eventIsShow;
      let data = {
        reportIds: this.selectedList.join(","),
      };
      if (this.tableIndex != 6) {
        data.isShow = 1;
      } else {
        data.isShow = 0;
      }
      this.isTableLoading = true;
      this.$post(url, data).then((res) => {
        if (res.isSucceed) {
          if (data.isShow == 1) {
            this.$Message.success("公示成功");
          } else {
            this.$Message.success("取消公示成功");
          }
          this.getSqEvent({});
          this.selectedList = [];
        }
      });
    },
    onSearch() {
      // console.log(
      //   this.$util.FormatDate(
      //     new Date(this.query.eventtime[0]).getTime(),
      //     "yyyy-MM-dd HH:mm:ss"
      //   )
      // );
      this.initSelVal();
      console.log(this.selectVal);
      // return
      this.page = 1;
      this.getSqEvent(this.selectVal);
    },
    initSelVal() {
      let title = this.query.title;
      let createuser = this.query.createuser;
      let reportId = this.query.reportId;
      let eventtime =
        this.query.eventtime[0] == ""
          ? ""
          : this.query.eventtime.map((item) => {
              // console.log(new Date(item).get)
              return this.$util.FormatDate(
                new Date(item).getTime(),
                "yyyy-MM-dd"
              );
            });
      console.log(this.query.eventtime);
      let name = "";
      switch (this.query.reportfromname) {
        case "先锋e家":
          name = "xfej";
          break;
        case "民生通":
          name = "mst";
          break;
        case "社区云助手":
          name = "sqyzs";

        case "东乡百事通":
          name = "dxbst";
      }
      let companyName = this.query.reportCompany;
      let communityIdList = [];
      if (companyName && companyName != "") {
        this.reportCompany.forEach((item, index) => {
          if (item.name == companyName) {
            communityIdList = item.communityId;
          }
        });
      }
      console.log(companyName);
      this.selectVal = {
        title,
        createuser,
        eventtime: eventtime == "" ? "" : eventtime.join(","),
        reportfromname: name,
        communityIdList,
        reportId,
      };
    },
    searchReset() {
      this.query = {
        title: "",
        createuser: "",
        eventtime: [],
        reportfromname: "",
        reportCompany: this.isJiedao ? "全部" : "",
      };
      this.selectVal = {
        title: "",
        createuser: "",
        eventtime: "",
        reportfromname: "",
        communityId: "",
      };
      this.getSqEvent(this.selectVal);
    },
    getSqEvent(queryEventParams) {
      let url = this.urlobj.getSqEvent;
      let data = {
        page: this.page,
        rows: this.rows,
        voteagree: this.tableList[this.tableIndex],
        queryEventParams: queryEventParams,
      };
      console.log(this.$store.state.streetorcommunityid);
      this.isTableLoading = true;
      if (this.tableIndex == 6) {
        data.isShow = 1;
      }
      this.$post(url, data).then((res) => {
        if (res.isSucceed) {
          // if (res.total == 0) {
          //   this.tableData = [];
          //   this.isTableLoading = false;
          //   return;
          // }
          this.isTableLoading = false;
          let eventList = res.rows.map((item) => {
            return {
              businesskey: item.reportid,
              state: item.nodename,
              from: item.reportfromname,
              title: item.title,
              bumen: item.community_name,
              people: item.createuser,
              time: this.$util.FormatDate(
                item.eventtime,
                "yyyy-MM-dd HH:mm:ss"
              ),
              evaluation: item.evaluation,
            };
          });
          this.total = parseInt(res.total);
          console.log(eventList);
          this.tableData = eventList;
        }
      });
    },
    getShequ() {
      this.$get(this.urlobj.getOrgAll).then((res) => {
        var clist = [];
        var ids = res.rows.map((item) => {
          return item.communityId;
        });
        var item = {
          name: "全部",
          communityId: ids,
        };
        clist = res.rows.map((item) => {
          return {
            name: item.communityName,
            communityId: [item.communityId],
          };
        });
        clist.unshift(item);
        console.log(clist);
        this.reportCompany = clist;
        if (this.isJiedao) {
          this.query.reportCompany = "全部";
        } else {
          clist.forEach((item) => {
            if (
              this.$store.state.streetorcommunityid ==
              item.communityId.join(",")
            ) {
              this.query.reportCompany = item.name;
            }
          });
        }
      });
    },
    exportTable() {
      this.initSelVal();
      console.log(this.selectVal);
      var uid = "-1";
      var voteagree = this.tableList[this.tableIndex];
      let url = this.urlobj.downSqsj(
        this.$store.state.streetorcommunityid,
        uid,
        voteagree
      );
      let title = this.selectVal.title;
      let createuser = this.selectVal.createuser;
      let isShow = 0;
      let communityId =
        this.selectVal.communityIdList.length > 1
          ? ""
          : this.selectVal.communityIdList.join(",");
      let eventtime = this.selectVal.eventtime;
      let reportfromname = this.selectVal.reportfromname;
      if (this.tableIndex == 6) {
        isShow = 1;
      }
      url =
        url +
        "?title=" +
        title +
        "&createuser=" +
        createuser +
        "&communityId=" +
        communityId +
        "&eventtime=" +
        eventtime +
        "&reportfromname=" +
        reportfromname +
        "&isShow=" +
        isShow;
      console.log(url);
      window.open(url);
    },
    handleClickDetail(item) {
      console.log(item);
      var evaluation = item.evaluation;
      // return
      // console.log(this.$store)
      this.$router.push({
        name: "sqEventDetail",
        query: { businesskey: item.businesskey },
      });
    },
    selChange(val) {
      console.log(val);
    },
  },
  created() {
    this.isJiedao = this.$store.state.isJiedao;
  },
  mounted() {
    if (this.isJiedao == 1) {
      this.getShequ();
    }
    this.getSqEvent(this.selectVal);
  },
};
</script>

<style lang='less' scoped>
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
  padding-bottom: 20px;
  /deep/ .ivu-input::-webkit-input-placeholder {
    /* placeholder颜色  */
    color: #999;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
    color: #999;
  }
  /deep/ .ivu-table-wrapper {
    border: 1px solid #e8eaec;
    border-bottom: 0;
    border-right: 0;
  }
  /deep/ th .ivu-table-cell {
    font-weight: 600;
  }
  /deep/ .ivu-table:after {
    display: none;
  }
  /deep/ .ivu-table:before {
    display: none;
  }
  /deep/ .ivu-table th {
    background-color: #f3f4f6;
  }
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}

.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}

.header {
  font-size: 25px;
  text-align: center;
}

.addManager {
  position: absolute;
  right: 20px;
}
.content {
  //   @content();
  // max-width: 96%;
  margin: 20px;
  overflow: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}

.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
}

.publicBtn {
  top: 0px;
  right: 10px;
  position: absolute;
}

.table-tabs {
  max-width: 100%;
  padding: 0;
  margin-top: 30px;

  /deep/ .ivu-tabs-bar {
    position: relative;
    margin-bottom: 2px;
    border-bottom: 0;
  }
  /deep/ .ivu-tabs-tab-active {
    color: white;
    background: #fe7d43;
    border-radius: 5px 5px 0 0;
  }
  /deep/ .ivu-tabs-ink-bar {
    height: 0px;
  }
  /deep/ .ivu-tabs-nav {
    padding-left: 10px;
    color: black;
  }
  /deep/ .ivu-tabs-tab {
    font-weight: bold;
  }
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
}

/deep/ .ivu-tabs-tab:hover {
  color: #ff7b44;
}
</style>
